import { render, staticRenderFns } from "./LabelAndAutoCompleteControl.vue?vue&type=template&id=23820bf2&"
import script from "./LabelAndAutoCompleteControl.vue?vue&type=script&lang=js&"
export * from "./LabelAndAutoCompleteControl.vue?vue&type=script&lang=js&"
import style0 from "./LabelAndAutoCompleteControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports